import { render } from "./LoginLayout.vue?vue&type=template&id=081d754d&scoped=true"
const script = {}

import "./LoginLayout.vue?vue&type=style&index=0&id=081d754d&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081d754d"]])

export default __exports__